import { useContext } from 'react';

import { ThemeActionsContext, ThemeStateContext } from './ThemeContext';
import type { ThemeActions, ThemeState } from './types';

export function useThemeState(): ThemeState {
    const state = useContext(ThemeStateContext);
    if (!state) throw new Error('useThemeState must be used within ThemeProvider');
    return state;
}

export function useThemeActions(): ThemeActions {
    const actions = useContext(ThemeActionsContext);
    if (!actions) throw new Error('useThemeActions must be used within ThemeProvider');
    return actions;
}
